import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../vuex/store'
import Wloading from 'iview/src/components/loading-bar'; //引入全局消息提示组件
import PageRoutes from './routes/index.js'
Vue.use(VueRouter)


const router = new VueRouter({
	// mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	},
	routes: [...PageRoutes]
})

router.beforeEach((to, from, next) => {
	let tokenId = store.getters.auth_tokenId;
	if (!tokenId) {
		window.location.href = 'login.html';
		return;
	}
	let path = to.path;
	let framework_isFirstLoad = store.getters.framework_isFirstLoad;
	console.log(to);
	if (path === '/' || framework_isFirstLoad) {
		store.dispatch('authFlushMenu', {
			'path': path,
			'router': router
		});
	}
	if (path != '/') {
		var label = to.name || '';
		var value = to.path || '';
		store.commit('ADD_TAG', {
			label: label,
			value: value,
			params: to.params,
			query: to.query,
			// group: router.$avueRouter.group || [],
			// moduleId: currentActiveModule,
			code: to.meta.code || ''
		});
	}

	Wloading.start();
	next();
})

router.afterEach(transition => {
	Wloading.finish();
});


export default router



// WEBPACK FOOTER //
// ./src/config/routes.js